// @ts-check
const CARTO_KEY = process.env.REACT_APP_CARTO_KEY;

export const BASE_MAP_URL =
  `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png?key=${CARTO_KEY}`;

export const MAP_ATTRIBUTION_URL =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/attributions">CARTO</a>';

/** @type {import("../types/global").BaseMap[]} */
export const BASE_MAPS = [
  { label: "CartoDB", enLabel: "CartoDB", value: BASE_MAP_URL },
  { label: "ESRI Uydu", enLabel: "ESRI Satellite", value: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" },
  { label: "ESRI Topoğrafik", enLabel: "ESRI Topographic", value: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}" },
  { label: "Google Uydu", enLabel: "Google Imagery", value: "https://mts0.google.com/vt/lyrs=y&x={x}&y={y}&z={z}" }
];

export const GeoJSON_STYLE = {
  fillColor: "#8ABE61",
  fillOpacity: 0.5,
  color: "#8ABE61",
  stroke: 1,
};